// eslint-disable-next-line no-use-before-define
import React, { FC, memo, useEffect } from 'react';
import { defTitle } from 'assets/strings';
import SimplesForm from 'components/modal/template/simplesForm';
import FormGenerator from 'components/Form/template/FormGenerator';

const ComponentClienteEditar: FC<any> = memo(oProps => {
    useEffect(() => {
        // eslint-disable-next-line no-undef
        document.title = `${defTitle} - Editar dados bancário`;
    });
    if (oProps.loadingBancoEntregador || oProps.initialData === null) {
        return null;
    }

    return (
        <SimplesForm
            rForm={oProps.rForm}
            handleSubmit={oProps.handleSubmit}
            loading={oProps.loading}
            titleSubmit={'Salvar'}
            titleModal={'Dados bancário'}
            message={null}>
            <FormGenerator
                rForm={oProps.rForm}
                childs={[
                    oProps.pix,
                    {
                        gridFirstWidth: 1,
                        items: [
                            {
                                type: 'hidden',
                                name: 'contaBancoId',
                                value: 1,
                            },
                            {
                                type: 'hidden',
                                value: "CONTACORRENTE",
                                name: 'contaTipo',
                            },
                        ],
                    },
                    {
                        gridFirstWidth: 1,
                        items: [
                            {
                                type: 'hidden',
                                value: "NULL NULL NULL",
                                name: 'titularNome',
                            },
                            {
                                type: 'hidden',
                                value: "923.243.390-72",
                                name: 'titularCpf',
                            },
                        ],
                    },
                    {
                        gridFirstWidth: 2,
                        items: [
                            {
                                type: 'hidden',
                                value: "0",
                                name: 'contaAgencia',
                            },
                            {
                                type: 'hidden',
                                value: "0",
                                name: 'contaAgenciaDv',
                            },
                        ],
                    },
                    {
                        gridFirstWidth: 2,
                        items: [
                            {
                                type: 'hidden',
                                value: "0",
                                name: 'contaNumero',
                            },
                            {
                                type: 'hidden',
                                value: "0",
                                name: 'contaNumeroDv',
                            },
                        ],
                    },
                ]}
            />
        </SimplesForm>
    );
});
export default ComponentClienteEditar;
